var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('v-card',{staticClass:"massanumberupload"},[_c('DragDropMassAnumberUpload')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }